/**
 * 供应商管理
 */
 import axios from '../request';
 export default{
    // 查询供应商信息
    searchSupplier: params =>
        axios.post('/engineering/supplier/supplierList', params),
    // 添加供应商信息
    insertSupplier: params =>
        axios.post('/engineering/supplier/supplierInsert', params),
    // 修改供应商信息
    updateSupplier: params =>
        axios.post('/engineering/supplier/supplierUpdate', params),
    // 供应商信息详情
    detailsSupplier: params =>
        axios.get('/engineering/supplier/supplierInfo', {params}),
    // 删除供应商信息
    deleteSupplier: params =>
        axios.get('/engineering/supplier/supplierDel', {params}),
 }